import React, { useEffect, useState } from "react";
import TableInvoices from "../../components/blocks/TableInvoices";
import { connect } from "react-redux";
import { getInvoicesInfo } from "../../store/actions/userInfo";
import FilterBlockDesktop from "../../components/blocks/FilterBlockDesktop";
import { cleanFilteredItems } from "../../store/actions/filters";

const Invoices = ({ userInfo, filteredItems, dispatch }) => {
  const tableHeadings = [
    "Дата",
    "Договір",
    "Тип нарахування",
    "Сума до оплати",
  ];
  const [invoiceTableItems, setInvoiceTableItems] = useState(null);

  useEffect(() => {
    if (userInfo) {
      dispatch(getInvoicesInfo(userInfo.company.id)).then((response) => {
        setInvoiceTableItems(response.data);
      });
    }
  }, [userInfo]);

  useEffect(() => {
    dispatch(cleanFilteredItems(invoiceTableItems));
  }, []);

  return (
    <div className="documents">
      <div className="documents__wrap">
        <div className="documents__title">Інформація за рахунками</div>
        <FilterBlockDesktop
          items={invoiceTableItems}
          datepicker="false"
          placeholder="Рік і місяць"
        />
        <TableInvoices
          className="table__general"
          data={
            invoiceTableItems &&
            filteredItems.sort((a, b) => new Date(b.date) - new Date(a.date))
          }
          headings={tableHeadings}
        />
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  const { userInfo } = state.userInfo,
    { filteredItems } = state.userInfo;

  return {
    userInfo,
    filteredItems,
  };
}

export default connect(mapStateToProps)(Invoices);
